import type { HotamClient } from '../client';

export type PingResponse = {
  service: 'hotam-api';
  status: 'ok';
};

export const getPing = async (client: HotamClient, signal?: AbortSignal): Promise<PingResponse> => {
  const payload = await client.request<PingResponse>('/ping', { signal });

  if (payload.status !== 'ok' || payload.service !== 'hotam-api') {
    throw new Error('Hotam API returned an unexpected ping response');
  }

  return payload;
};
